;

try{
    nanesenieButtons();
} catch (e) {
    console.error('nanesenieButtons module crashed: ' + e.message);
}

function nanesenieButtons() {

    if(!$('.nanesenie_buttons'))
        return false;

    var selector = {
        additional_nanesenie_wrapper: ".additional_nanesenie_wrapper",
        button_container: ".nanesenie_buttons",
        buttons: ".nanesenie_button",
        tab_container: ".tabs",
        tabs: ".tabs .tab",
        form_wrapper: ".additional_nanesenie_wrapper .form-wrapper",
        bottomButton: '.tabs .tabs-bottom-button'
    };

    var tab_container = $(selector.tab_container),
        form_wrapper = $(selector.form_wrapper),
        tabs = $(selector.tabs),
        buttons = $(selector.buttons);


    $(selector.button_container).on('click', selector.buttons, showTab);
    $(selector.button_container).on('mouseover', selector.buttons, showTab);

    function showTab() {
        var current_button = $(this),
            tab = current_button.data('tab');
        tab_container.show();
        buttons.removeClass("active");
        current_button.addClass("active");

        tabs.hide(0);
        $("." + tab).show(0);
    }

    /*
    $(selector.additional_nanesenie_wrapper).on('mouseleave', function() {
        buttons.removeClass("active");
        tab_container.hide();
        form_wrapper.hide();
    });
    */

    $(selector.bottomButton).on('click', function() {
        $(selector.form_wrapper).toggle();
    });
}



// WEBPACK FOOTER //
// ./assets/javascript/nanesenieButtons.js